module.exports = __webpack_public_path__ + "static/pomodoro-d222529b06fa3f0e68756830f9fe0808.png";